import elasticSideBar from './elasticSideBar';
export default elasticSideBar;



// WEBPACK FOOTER //
// ./src/components/elasticSideBar/index.js